export default {
  zh: {
    topNav: {
      dashboard: '数据汇总',
      leads: '潜在客户',
      accounts: '客户',
      opportunities: '机会',
      reports: '报告'
    },
    topOperations: {
      signOut: '退出',
      myAccount: '我的账户'
    },
    footer: {
      copyright: 'Copyright © 2022 www.zerologix.com All rights reserved.'
    },
    setup: {
      welcome: '欢迎到LogixCRM设置页'
    }
  },
  en: {
    topNav: {
      dashboard: 'dashboard',
      leads: 'leads',
      accounts: 'accounts',
      opportunities: 'opportunities',
      reports: 'reports'
    },
    topOperations: {
      signOut: 'Sign Out',
      myAccount: 'My Account'
    },
    footer: {
      copyright: 'Copyright © 2022 www.zerologix.com All rights reserved.'
    },
    setup: {
      welcome: 'Welcome to LogixCRM setup page'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/global/crm.js